import { StyledFormGroup } from "../styled-form-group";
import { NumericInput } from "@blueprintjs/core";
import React from "react";
import "styled-components/macro";

export function FareInput({
  formState,
  formActions,
  activeField,
  setActiveField,
  data_testid,
  helperText,
  label,
  isVisible = true,
}) {
  return !isVisible ? null : (
    <StyledFormGroup
      helperText={helperText}
      label={label}
      labelFor="price"
      activeField={activeField}
    >
      <div>
        <NumericInput
          data-testid={data_testid}
          name="price"
          value={formState.price}
          onValueChange={(v, value) => formActions.setPrice(value)}
          buttonPosition={"none"}
          leftIcon="dollar"
          large
          onFocus={() => setActiveField("price")}
          css={`
            input {
              width: 190px !important;
            }
          `}
        />
      </div>
    </StyledFormGroup>
  );
}
